import React from 'react';
import {
  Box,
  makeStyles,
  createStyles,
  useTheme,
  useMediaQuery,
  IconButton,
  Theme,
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { ChevronLeft } from '@material-ui/icons';
import BaseTypography from '../Text/BaseTypography';
import { BackIcon } from '../Icons';
import { PLAN_PAGE } from '../../constants';
import useNavigate from '../../hooks/useNavigate';
import { usePlanStatus } from '../../hooks/usePlanStatusHook';
import { DescriptionTooltip } from '../Tooltip';
import { BlackHeadings } from '../../theme/colors';

import { typography12MediumStyle } from '../Text';
import Button from '../Button';
import { RootState } from '../../store';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    selectPlanButton: {
      color: BlackHeadings,
      textDecoration: 'underline',
      ...typography12MediumStyle,
    },
    backToggleMobile: {
      padding: 0,
      marginRight: theme.spacing(1),
    },
  }),
);

export const SettingsSidebarBackToggle = () => {
  const classes = useStyles();
  const { navigate } = useNavigate();
  const theme = useTheme();
  const isSmScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const backToPortalDestinationPath = useSelector(
    (state: RootState) => state.ui.backToPortalDestinationPath,
  );
  const { isTrialPeriodExpired, isCancelledPlan, isPaidPlan } = usePlanStatus();

  const handleBackToggleClicked = () => {
    navigate(backToPortalDestinationPath);
  };

  // disable back toggle on settings screen
  const disableBackToggle =
    (isTrialPeriodExpired || isCancelledPlan) && !isPaidPlan;
  const backToggleRenderer = () => {
    if (isSmScreen) {
      return (
        <IconButton
          disabled={disableBackToggle}
          onClick={handleBackToggleClicked}
          className={classes.backToggleMobile}
        >
          <ChevronLeft />
        </IconButton>
      );
    }

    return (
      <Button
        disabled={disableBackToggle}
        htmlId="settings-sidebar-back-toggle"
        startIcon={<BackIcon />}
        variant="text"
        color="primary"
        onClick={handleBackToggleClicked}
      >
        <BaseTypography fontType="13Medium">Go back</BaseTypography>
      </Button>
    );
  };

  const goToPlanSettings = () => {
    navigate(PLAN_PAGE.path);
  };

  return disableBackToggle ? (
    <DescriptionTooltip
      placement="bottom-start"
      interactive
      title={
        <BaseTypography fontType="12Medium" style={{ color: BlackHeadings }}>
          To continue using Portal please{' '}
          <Button
            htmlId="go-to-select-plan-btn"
            variant="text"
            onClick={goToPlanSettings}
            className={classes.selectPlanButton}
          >
            select a plan
          </Button>
        </BaseTypography>
      }
    >
      <Box>{backToggleRenderer()}</Box>
    </DescriptionTooltip>
  ) : (
    backToggleRenderer()
  );
};
